export default __webpack_public_path__ + "static/media/HK.e0fece00.svg";